import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import { APP } from 'src/Configs/App'
import {
  getDefaultStartDate,
  getIsMoreThenDaysLeft,
} from 'src/Constants/functions'
import { ErrorCode, NameSpace } from 'src/Redux/types'
import { invalidateTiktokCampaignDetails } from 'src/Redux/campaignTiktokDetailsApi'
import { api } from 'src/Services/api'
import { TikTokUpdateCampaign, TiktokCampaign } from 'src/Types/campaigns'

export const updateTikTokCampaign = createAsyncThunk<
  TiktokCampaign,
  TikTokUpdateCampaign
>(
  `${NameSpace.TiktokCampaign}/updateTikTokCampaign`,
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await api.put<TiktokCampaign>(
        `${APP.TIKTOK_SERVER}/artist/tiktok/campaign/${payload.id}`,
        payload,
      )
      dispatch(invalidateTiktokCampaignDetails(payload.id))
      return data
    } catch (error) {
      const { response } = error as AxiosError<{ message: string }>
      return rejectWithValue({
        message: response?.data.message,
        code: response?.status || ErrorCode.InternalServerError,
      })
    }
  },
)

export const getCampaignTikTokCampaignToScheduleDetails = createAsyncThunk<
  TiktokCampaign,
  { tiktokCampaignId: number; hasPlan?: boolean }
>(
  `${NameSpace.TiktokCampaign}/getCampaignTikTokCampaignToScheduleDetails`,
  async ({ tiktokCampaignId, hasPlan }, { rejectWithValue }) => {
    try {
      const { data } = await api.get<TiktokCampaign>(
        `${APP.TIKTOK_SERVER}/artist/tiktok/campaigns/${tiktokCampaignId}`,
      )
      const isMoreThenMinDaysLeft = getIsMoreThenDaysLeft(data.startDate)

      return {
        ...data,
        startDate: !isMoreThenMinDaysLeft
          ? getDefaultStartDate(hasPlan)
          : data.startDate,
      }
    } catch (error) {
      const { response } = error as AxiosError<{ message: string }>
      return rejectWithValue({
        message: response?.data.message,
        code: response?.status || ErrorCode.InternalServerError,
      })
    }
  },
)
